var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4723749-C996-4628-97C7-A8DAC243E14A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.86666667,13.9951807 L1.75238095,7.98072289 L9.86666667,1.96626506 L9.86666667,0 L0.60952381,6.82409639 C0.228571429,7.0939759 0,7.51807229 0,7.98072289 C0,8.44337349 0.228571429,8.86746988 0.60952381,9.1373494 L9.86666667,16 L9.86666667,13.9951807 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fleets-(old_version)",
    transform: "translate(-824.000000, -128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-&-Filters",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown-copy-2-dropdown",
    transform: "translate(664.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/01_UI/arrow_down/24---",
    transform: "translate(132.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bouncing-area",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ERGO_Icon_UI_arrow_left_rgb_black",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) translate(7.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "02_grey/07_darkest-02_grey/06_darker",
    mask: "url(#mask-2)",
    fill: "#737373"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.000000, -13.000000)",
    id: "Rectangle-Copy-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 42 0 42 42 0 42"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6efd012c94a89ff61655ca0a608b029c.svg";
export { ForwardRef as ReactComponent };